<template>
  <div>
    <v-btn
      @click="dialog = true"
      fab
      class="mx-2 pa-0 genaralIcons"
      small
      style="left: 20px"
      :color="$vuetify.theme.themes.light.BtnBKColor"
      depressed
      width="35"
      height="35"
      title="بحث"
    >
      <SearchIcon />
    </v-btn>

    <v-btn
      @click="dialogOfCreating = true"
      fab
      class="mx-2 pa-0 genaralIcons"
      small
      style="left: 80px; background-color: white"
      :color="$vuetify.theme.themes.light.BtnBKColor"
      depressed
      width="35"
      height="35"
      title="اضافة اعدادات جديده للرهن"
    >
      <img
        src="@/assets/icons/add-icon-svgrepo-com.svg"
        width="35"
        height="35"
      />
    </v-btn>

    <!-- search -->
    <v-dialog v-model="dialog" persistent width="60%">
      <v-card style="padding: 10px">
        <v-card-title>البحث</v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                :items="mortgageSettingItems"
                label="نوع الاعدادات"
                v-model="type_of_setting"
                outlined
                item-text="value"
                item-value="id"
                dense
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :id="attrs['aria-labelledby']"
                      v-text="item['value']"
                    ></v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                :items="['غير نشط', 'نشط']"
                label="حالة الاعدادات"
                v-model="active_or_not"
                outlined
                dense
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :id="attrs['aria-labelledby']"
                      v-text="item"
                    ></v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="dialog = false">
            الغاء
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="handleSearch">
            بحث
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- add new mortgage settings -->

    <v-dialog v-model="dialogOfCreating" persistent width="60%">
      <v-card style="padding: 10px">
        <v-card-title>أضافة اعدادات لطلبات الرهن</v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                :items="mortgageSettingItems"
                label="نوع الاعدادات"
                v-model="type_of_setting_in_creating"
                item-text="value"
                item-value="id"
                outlined
                dense
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :id="attrs['aria-labelledby']"
                      v-text="item['value']"
                    ></v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                :items="['غير نشط', 'نشط']"
                label="حالة الاعدادات"
                v-model="active_or_not_in_creating"
                outlined
                dense
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :id="attrs['aria-labelledby']"
                      v-text="item"
                    ></v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="قيمة الاعدادات"
                v-model="value_in_creating"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogOfCreating = false"
          >
            الغاء
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="addNewSetting">
            اضافة
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- edit  mortgage settings -->
    <v-dialog
      v-model="$store.state.open_edit_dialog_mortgage_settings"
      persistent
      width="60%"
    >
      <v-card style="padding: 10px">
        <v-card-title>تعديل اعدادات لطلبات الرهن</v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                :items="mortgageSettingItems"
                label="نوع الاعدادات"
                v-model="edited_setting.mortgage_setting_data_id"
                item-text="value"
                item-value="id"
                outlined
                dense
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :id="attrs['aria-labelledby']"
                      v-text="item['value']"
                    ></v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                :items="['غير نشط', 'نشط']"
                label="حالة الاعدادات"
                v-model="edited_setting.active_as_text"
                outlined
                dense
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :id="attrs['aria-labelledby']"
                      v-text="item"
                    ></v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="قيمة الاعدادات"
                v-model="edited_setting.value"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="$store.state.open_edit_dialog_mortgage_settings = false"
          >
            الغاء
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="updateSetting">
            تعديل
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SearchIcon } from "@/assets/adminIcons/searchIcon";
import { axiosInstance } from "@/axios/config";
export default {
  components: {
    SearchIcon,
  },
  data() {
    return {
      dialog: false,
      dialogOfCreating: false,
      type_of_setting: "",
      active_or_not: "",
      type_of_setting_in_creating: "",
      active_or_not_in_creating: "",
      value_in_creating: "",
      edited_setting: {},

      mortgageSettingItems:[],
    };
  },

  watch: {
    "$store.state.id_of_mortgage_settings": {
      handler() {
        this.openSettingToUpdate();
      },
    },
  },

  methods: {
    handleSearch() {
      this.dialog = false;
      const body = new FormData();

      // if (this.type_of_setting === "احتياجات العميل") {
      //   body.append("type_of_setting", "customer_needs");
      // } else if (this.type_of_setting === "الاعتراضات والتحديات") {
      //   body.append("type_of_setting", "objections_challenges");
      // } else if (this.type_of_setting === "المعوقات") {
      //   body.append("type_of_setting", "obstacles");
      // }

      body.append("type_of_setting", this.type_of_setting);

      if (this.active_or_not === "نشط") {
        body.append("active_or_not", 1);
      } else if (this.active_or_not === "غير نشط") {
        body.append("active_or_not", 0);
      }

      axiosInstance
        .post(`/employee/admin/all-mortgage-settings`, body)
        .then((res) => {
          this.$emit("filterData", res.data.payload);
        });
    },

    addNewSetting() {
      const body = new FormData();

      // if (this.type_of_setting_in_creating === "احتياجات العميل") {
      //   body.append("type", "customer_needs");
      // } else if (this.type_of_setting_in_creating === "الاعتراضات والتحديات") {
      //   body.append("type", "objections_challenges");
      // } else if (this.type_of_setting_in_creating === "المعوقات") {
      //   body.append("type", "obstacles");
      // }

      body.append("mortgage_setting_data_id", this.type_of_setting_in_creating);
      body.append("value", this.value_in_creating);


      if (this.active_or_not_in_creating === "نشط") {
        body.append("status", 1);
      } else if (this.active_or_not_in_creating === "غير نشط") {
        body.append("status", 0);
      }


      axiosInstance
        .post(`/employee/admin/add-mortgage-settings`, body)
        .then((res) => {
          this.dialogOfCreating = false;
          this.$emit("settingsIsAdded");
          this.showPopup("success", res.data.message);

          this.type_of_setting_in_creating = "";
          this.active_or_not_in_creating = "";
          this.value_in_creating = "";
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },

    openSettingToUpdate() {
      axiosInstance
        .get(
          `/employee/admin/edit-mortgage-settings/${this.$store.state.id_of_mortgage_settings}`,
          { headers: this.request_headers() }
        )
        .then((res) => {
          console.log(res.data.payload.data)
          this.edited_setting = res.data.payload.data;
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },

    updateSetting() {
      const body = new FormData();

      // if (this.edited_setting.type === "أحتياجات العميل") {
      //   body.append("type", "customer_needs");
      // } else if (this.edited_setting.type === "الاعتراضات والتحديات") {
      //   body.append("type", "objections_challenges");
      // } else if (this.edited_setting.type === "المعوقات") {
      //   body.append("type", "obstacles");
      // }

      body.append("mortgage_setting_data_id", this.edited_setting.mortgage_setting_data_id);
      body.append("value", this.edited_setting.value);
     

      if (this.edited_setting.active_as_text === "نشط") {
        body.append("status", 1);
      } else if (this.edited_setting.active_as_text === "غير نشط") {
        body.append("status", 0);
      }


      axiosInstance
        .post(`/employee/admin/update-mortgage-settings/${this.$store.state.id_of_mortgage_settings}`, body)
        .then((res) => {
          this.$store.state.open_edit_dialog_mortgage_settings = false;
          this.$emit("settingsIsAdded");
          this.showPopup("success", res.data.message);
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },

    getMainMortgageSettings() {
      axiosInstance
        .post(`employee/admin/all-mortgage-settings-data`)
        .then((res) => {
          this.mortgageSettingItems = res.data.payload.data;
          this.mortgageSettingItems.map((item) => {
            item["color"] = "red";
            item["text"] = item["value"];
            return item;
          });
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
  },

  mounted() {
    this.getMainMortgageSettings();
  },

};
</script>

<style>
.genaralIcons {
  position: absolute;
  top: -50px;
  min-width: unset;
  z-index: 5;
}
</style>

